import { COLORS } from '../styles/colors';
import * as Icons from './lib';

import type { IconProps } from './Icon.types';

import { S } from './Icon.styles';

export const ICON_SIZES = {
  small: 12,
  medium: 16,
  large: 20,
  xlarge: 32,
  xxlarge: 60
};

export const Icon = ({
  name,
  size = 'medium',
  color = 'charcoal-500',
  rotation = 0,
  className
}: IconProps) => {
  const pixelSize = ICON_SIZES[size];
  const props = {
    fill: COLORS[color],
    width: pixelSize,
    height: pixelSize,
    rotation,
    className
  };

  const IconComponent = Icons[name];

  return (
    <S.IconWrapper width={pixelSize} height={pixelSize}>
      {IconComponent && <IconComponent {...props} />}
    </S.IconWrapper>
  );
};
